import React from 'react'
import { Link } from 'react-router-dom'
import checkedImage from '../../../img/SRA/checked.png';
import checkedLightImage from '../../../img/SRA/checked_light.png';

// Section on SRA Main Page
const SRASection = ({
    sectionKey,
    backendSectionName,
    sectionProgress,
    sectionName,
    completeImage,
    incompleteImage }
) => {
    return (
        <div className={`risk__progress ${sectionProgress >= 100 ? "complete" : ""}`}>
            <Link to={{
                pathname: `/app/assessment/security-risk-assessment/${sectionName.toLowerCase().replace(/ /g, '-')}`,
                state: {
                    backendSectionName: backendSectionName,
                    sectionNumber: sectionKey + 1,
                    sectionName: sectionName
                }
            }}>
                <div>
                    <p>Section {sectionKey + 1}: {sectionName}</p>

                    <div className="progress__sections">
                        <img
                            src={sectionProgress < 100 ? incompleteImage : completeImage}
                            alt={`${sectionName}`}
                        />
                        <span>Progress: {sectionProgress} </span>
                    </div>
                    <img
                        className="checked__image"
                        src={sectionProgress < 100 ? checkedImage : checkedLightImage}
                        alt='check mark'
                    />
                </div>
            </Link>
        </div>
    )
}

export default SRASection


// WEBPACK FOOTER //
// ./src/components/sra/components/SRASection.js